import { motion } from 'framer-motion'
import {
  MapPin,
  MessagesSquare,
  CalendarDays,
  ShieldCheck,
  Star,
  CreditCard,
} from 'lucide-react'
import { Card, CardContent } from './ui/card'

const features = [
  {
    icon: MapPin,
    title: 'Real-time Tracking',
    description: 'Track your service provider in real-time, just like with ride-sharing apps.'
  },
  {
    icon: MessagesSquare,
    title: 'Built-in Messaging',
    description: 'Communicate directly with service providers through our secure messaging system.'
  },
  {
    icon: CalendarDays,
    title: 'Smart Booking',
    description: 'Easy scheduling with availability management and recurring appointment support.'
  },
  {
    icon: ShieldCheck,
    title: 'Verified Providers',
    description: 'All service providers are background-checked and verified for your safety.'
  },
  {
    icon: Star,
    title: 'Review System',
    description: 'Transparent reviews and ratings help you choose the best service providers.'
  },
  {
    icon: CreditCard,
    title: 'Secure Payments',
    description: 'Safe, secure payments with escrow protection and multiple payment options.'
  }
]

const Features = () => {
  return (
    <section id="features" className="py-20 bg-muted/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Everything you need in one platform
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            From discovery to completion, we've built all the tools you need for seamless service coordination.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card className="h-full p-6 transition-shadow hover:shadow-md hover:ring-foreground/20">
                <CardContent className="px-0">
                  <div className="w-12 h-12 bg-primary/15 rounded-lg flex items-center justify-center mb-4">
                    <feature.icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-2">{feature.title}</h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features